module.exports = __webpack_public_path__ + "static/media/facebook-icon.fa7668a3.svg";